import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";


import { Draft } from "immer";

export interface QuoteCartState {
    isLoading: boolean;
    quoteCount: number;
}

const initialState: QuoteCartState = {
    isLoading: false,
    quoteCount:0,
};
const QuoteCartReducer = {
    "Custom/Quote/BeginLoadQuoteCount": (draft: Draft<QuoteCartState>) => {
        draft.isLoading = true;
    },
    "Custom/Quote/CompletedLoadQuoteCount": (
        draft: Draft<QuoteCartState>,
        action:{
            quoteCount: number
        }
    ) => {
        draft.quoteCount = action.quoteCount;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, QuoteCartReducer);
